<template>
  <div><span>正在支付……</span></div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import { aliPay } from '@api/train'

@Component
export default class AliPay extends Vue {
  name = 'Linus'
  async handleAliPay(priceId) {
    const form = await aliPay(priceId)
    const div = document.createElement('div')
    div.innerHTML = form
    document.body.appendChild(div)
    document.forms.punchout_form.submit()
  }
  created() {
    this.handleAliPay(this.$route.query.priceId)
  }
}
</script>
<style></style>
